export type ViewBoxInfo = {
  l: number;
  r: number;
  w: number;
  h: number;
  viewBoxString: string;
};

export interface SolfegeHandSignGlyphMetrics {
  path: string;
  viewBoxInfo: ViewBoxInfo;
}

export function solfegeHandSignGlyphToHtmlString(glyph: SolfegeHandSignGlyphMetrics, alt: string, options: { stroke?: number }): string {
  const stroke = 'stroke-width: ' + ((options.stroke || 0) ) + 'px;';
  return `<svg viewBox="${glyph.viewBoxInfo.viewBoxString}" style="fill: currentColor; ${stroke} stroke: currentColor; height: 1em;">
    <title>${alt}</title>
    <path d="${glyph.path}" />
  </svg>`
}


export { di2Self } from './glyph-paths/di2Self'
export { di2Teacher } from './glyph-paths/di2Teacher'
export { diSelf } from './glyph-paths/diSelf'
export { diTeacher } from './glyph-paths/diTeacher'
export { doSelf } from './glyph-paths/doSelf'
export { doTeacher } from './glyph-paths/doTeacher'
export { downArrow } from './glyph-paths/downArrow'
export { faSelf } from './glyph-paths/faSelf'
export { faTeacher } from './glyph-paths/faTeacher'
export { fiSelf } from './glyph-paths/fiSelf'
export { fiTeacher } from './glyph-paths/fiTeacher'
export { laSelf } from './glyph-paths/laSelf'
export { laTeacher } from './glyph-paths/laTeacher'
export { leSelf } from './glyph-paths/leSelf'
export { leTeacher } from './glyph-paths/leTeacher'
export { liSelf } from './glyph-paths/liSelf'
export { liTeacher } from './glyph-paths/liTeacher'
export { meSelf } from './glyph-paths/meSelf'
export { meTeacher } from './glyph-paths/meTeacher'
export { miSelf } from './glyph-paths/miSelf'
export { miTeacher } from './glyph-paths/miTeacher'
export { raSelf } from './glyph-paths/raSelf'
export { raTeacher } from './glyph-paths/raTeacher'
export { reSelf } from './glyph-paths/reSelf'
export { reTeacher } from './glyph-paths/reTeacher'
export { riSelf } from './glyph-paths/riSelf'
export { riTeacher } from './glyph-paths/riTeacher'
export { seSelf } from './glyph-paths/seSelf'
export { seTeacher } from './glyph-paths/seTeacher'
export { siSelf } from './glyph-paths/siSelf'
export { siTeacher } from './glyph-paths/siTeacher'
export { solSelf } from './glyph-paths/solSelf'
export { solTeacher } from './glyph-paths/solTeacher'
export { teSelf } from './glyph-paths/teSelf'
export { teTeacher } from './glyph-paths/teTeacher'
export { tiSelf } from './glyph-paths/tiSelf'
export { tiTeacher } from './glyph-paths/tiTeacher'
export { upArrow } from './glyph-paths/upArrow'
